import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { ticketInsuranceStatusMessages } from './messages'
import { TICKET_INSURANCE_STATUS } from './constants'

export const getStatusColor = (status: TSFixMe): TSFixMe => {
  switch (status) {
    case TICKET_INSURANCE_STATUS.CONFIRMED:
      return '#66BB6A'
    case TICKET_INSURANCE_STATUS.RESERVED:
      return '#2E7D32'
    case TICKET_INSURANCE_STATUS.CANCELLED:
    case TICKET_INSURANCE_STATUS.PARTIALLY_CANCELLED:
      return '#9E9E9E'
    case TICKET_INSURANCE_STATUS.EXPIRED:
      return '#5D5C70'
    case TICKET_INSURANCE_STATUS.FAILED:
    case TICKET_INSURANCE_STATUS.CREATION_FAILED:
    case TICKET_INSURANCE_STATUS.CANCELLATION_FAILED:
    case TICKET_INSURANCE_STATUS.EDIT_FAILED:
      return '#F57C00'
  }
}

const Status = styled.div<TSFixMe>`
  color: ${(props): TSFixMe => getStatusColor(props.status)};
`

export const TicketInsuranceStatus = ({ status }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  if (ticketInsuranceStatusMessages[status]) {
    return <Status status={status}>{intl.formatMessage(ticketInsuranceStatusMessages[status])}</Status>
  }

  return <div>{status}</div>
}
